// @flow
import { connect } from 'react-redux';
import { disbatch } from 'redux-act';

import { selectCartUUID, getCart } from '@gandi/cart';
import type { TranslatorProps } from '@gandi/translate';

import BulkAddToCart, { type StateProps } from '../../components/BulkAddToCart';
import type { FullState, Dispatch, GetState } from '../../types';
import {
  removeFromCart,
  addRenewableAndServices,
  setCartProductState,
} from '../modules/actions';
import {
  selectExtendedResults,
  selectRenewableResultsToAdd,
} from '../modules/selectors';

const selectAllAddedToCart = (state: FullState): boolean =>
  selectExtendedResults(state)
    .filter(result => result.renewable || result.restorable)
    .every(result => result.addedToCart);

const mapStateToProps = (state: FullState): StateProps => ({
  addedToCart: selectAllAddedToCart(state),
  cartId: selectCartUUID(state),
});

const addAllToCart =
  (translator: TranslatorProps) =>
  async (dispatch: Dispatch, getState: GetState) => {
    const resultsToAdd = selectRenewableResultsToAdd(getState());

    try {
      disbatch(
        dispatch,
        resultsToAdd.map(({ fqdn }) =>
          setCartProductState({ fqdn, cartProductState: 'adding' }),
        ),
      );
      await dispatch(addRenewableAndServices(resultsToAdd, translator));
    } finally {
      disbatch(
        dispatch,
        resultsToAdd.map(({ fqdn }) =>
          setCartProductState({ fqdn, cartProductState: 'none' }),
        ),
      );
    }

    return dispatch(getCart());
  };

const removeAllFromCart = () => (dispatch: Dispatch, getState: GetState) => {
  const results = selectExtendedResults(getState());

  return Promise.allSettled(
    results
      .filter(result => result.addedToCart)
      .map(result => dispatch(removeFromCart(result))),
  );
};

const mapDispatchToProps = {
  addAllToCart,
  removeAllFromCart,
};

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps, mapDispatchToProps)(BulkAddToCart);
